import { vsprintf } from 'sprintf-js';

const MESSAGES = {
	LOCALE_CREATOR_CREATE_TITLE: "Create",
	LOCALE_LIST_TITLE: "Current Locales",
	RESOURCES_DOWNLOADING_SHORT: "Downloading...",
	RESOURCES_DOWNLOADING: "Downloading resources...",
	RESOURCES_DOWNLOADED_SUCCESSFULLY: "Resources successfully downloaded as \"%s\"",
	RESOURCES_DOWNLOADED_WARNING: "Resources downloaded successfully however...",
	RESOURCES_DOWNLOADED_WARNING_MISSING_TRANSLATIONS: "The following locales are missing some translations: %s",
	RESOURCES_DOWNLOADED_WARNING_MISSING_VALIDATIONS: "The following locales are missing some validations: %s",
	RESOURCES_NO_AVAILABILITY: "There are no resources available to download.",
	INVITE_TEXT: "Welcome to Tovertaal. Please enter a password.",
	FORGOT_PASSWORD_SUCCESS: "You will receive an email at the specified address if an account exists."
};

export function message(key, ...args) {
	return vsprintf(MESSAGES[key], args);
}


// WEBPACK FOOTER //
// ./src/messages.js